// extracted by mini-css-extract-plugin
export var banner = "_rj-0";
export var settingRow = "_rj-2";
export var titleIcon = "_rj-1";